import apiClient from "../apiClient";

//................. Sidebar Api's...................//

export const getChangePassword = (data) =>
  apiClient.post("/Auth/change-password", data);

//................. Dashboard Api's...................//

export const getOwnerDashboardData = () =>
  apiClient.get("/owner/dashboard", {});

//................. Society and Amenities Api's...................//

export const getSocietiesList = (params) =>
  apiClient.get("/owner/societies", { params });

export const getSocietyAmenitiesList = () =>
  apiClient.get("/owner/societies/amenities", {});

export const createSociety = (data) => apiClient.post("/owner/societies", data);

export const getSocietyListById = (id) =>
  apiClient.get(`/owner/societies/${id}`);

export const updateSocietyListById = (id, data) =>
  apiClient.post(`/owner/societies/${id}`, data);

export const toggleSocietyStatusById = (id, data) =>
  apiClient.post(`/owner/societies/${id}/toggle`, data);

//................. Society Properties And Rooms Api's...................//

export const getMasterPropertyTypes = () =>
  apiClient.get("/master/property-types");

export const getMasterChargeTypes = () => apiClient.get("/master/charge-types");

export const getProperties = (params) =>
  apiClient.get("/owner/properties", { params });

export const createProperties = (data) =>
  apiClient.post("/owner/properties", data);

export const getPropertyById = (id) => apiClient.get(`/owner/properties/${id}`);

export const updatePropertyById = (id, data) =>
  apiClient.post(`/owner/properties/${id}`, data);

export const getTenantsList = () =>
  apiClient.get("/owner/properties/getTenants");

export const assignTenantToProperty = (id, data) =>
  apiClient.post(`/owner/properties/${id}/assign`, data);

export const togglePropertyStatusById = (id, data) =>
  apiClient.post(`/owner/properties/${id}/toggle`, data);

export const vacantTenantyById = (id) =>
  apiClient.post(`/owner/properties/${id}/vacate`);

//................. Society  And Tenant Api's...................//

export const getMasterIndustryList = () => apiClient.get("/master/industries");

export const getAssignToPropertyList = () =>
  apiClient.get("/owner/properties/picker");

export const getOccupationByIndustryId = (industryId) =>
  apiClient.get(`/master/occupations`, { params: { industryId } });

export const getTenants = (params) =>
  apiClient.get("/owner/tenants", { params });

export const createTenants = (data) => apiClient.post("/owner/tenants", data);

export const getTenantsById = (id) => apiClient.get(`/owner/tenants/${id}`);

export const updateTenantsById = (id, data) =>
  apiClient.post(`/owner/tenants/${id}`, data);

export const toggleTenantStatusById = (id, data) =>
  apiClient.post(`/owner/tenants/${id}/toggle`, data);

export const BedAssignmentForTenant = (id) =>
  apiClient.get(`/owner/tenants/${id}/bed-assignment`);

export const getPgPropertyForId = () => apiClient.get("/owner/pg-properties");

export const getBedPickerForBedAssignment = (id) =>
  apiClient.get(`/owner/tenants/bed-picker?pgPropertyId=${id}`);

export const assignBedToTenant = (id, data) =>
  apiClient.post(`/owner/tenants/${id}/assign-bed`, data);

export const unassignBedToTenant = (id) =>
  apiClient.post(`/owner/tenants/${id}/unassign-bed`);

export const getFoodPlanForTenant = (id) =>
  apiClient.get(`/owner/pg-management/properties/${id}/food-plans`);

export const allotedFoodPlanForTenant = (id) =>
  apiClient.get(`/owner/pg-management/tenants/${id}/food-plan`);

export const assignFoodPlanToTenant = (id, data) =>
  apiClient.post(`/owner/pg-management/tenants/${id}/assign-food-plan`, data);

export const getManageBedList = (id) =>
  apiClient.get(`/owner/pg-management/rooms/${id}/beds`);

export const getManageBedSharingType = () =>
  apiClient.get("/owner/pg-management/sharing-types");

export const saveManageBeds = (data) =>
  apiClient.post(`/owner/pg-management/beds/save`, data);

export const deleteManageBed = (id) =>
  apiClient.post(`/owner/pg-management/beds/${id}/delete`);

export const toggleManageBed = (id) =>
  apiClient.post(`/owner/pg-management/beds/${id}/toggle`);

//................. KYC Doc Setting Api's...................//

export const getKYCDocSettings = () => apiClient.get("/owner/kyc-doc-settings");

export const saveKycDocSettingMode = (data) =>
  apiClient.post("/owner/kyc-doc-settings/mode", data);

export const kycDocumentCategory = (mode) =>
  apiClient.get(`/master/kyc-doc-categories?kycMode=${mode}`);

export const kycDocumentTypes = (mode) =>
  apiClient.get(`/master/kyc-doc-types?digiLockerOnly=false`);

export const addKycDocument = (data) =>
  apiClient.post("/owner/kyc-doc-settings/documents/add", data);

export const getKycDocumentById = (id) =>
  apiClient.get(`/owner/kyc-doc-settings/documents/${id}`);

export const updateKycDocument = (id, data) =>
  apiClient.post(`/owner/kyc-doc-settings/documents/${id}/update`, data);

export const toggleKycDocument = (id) =>
  apiClient.post(`/owner/kyc-doc-settings/documents/${id}/toggle`);

export const removeKycDocument = (id) =>
  apiClient.post(`/owner/kyc-doc-settings/documents/${id}/delete`);

//................. Vacate Request Api's...................//

export const getVacateRequestList = () =>
  apiClient.get("/owner/vacate-requests");

export const getVacateRequestById = (id) =>
  apiClient.get(`/owner/vacate-requests/${id}`);

export const updateVacateRequestById = (id, data) =>
  apiClient.post(`/owner/vacate-requests/${id}/edit`, data);

export const approveVacateRequest = (id, data) =>
  apiClient.post(`/owner/vacate-requests/${id}/approve`, data);

export const rejectVacateRequest = (id, data) =>
  apiClient.post(`/owner/vacate-requests/${id}/reject`, data);

export const getVacateNoticeSetting = () =>
  apiClient.get("/owner/vacate-requests/settings");

export const updateVacateNoticeSetting = (data) =>
  apiClient.post("/owner/vacate-requests/settings", data);

//................. Support Ticket Api's...................//

export const getSupportTicketList = (params) =>
  apiClient.get("/owner/support-tickets", { params });

export const getSupportTicketById = (id) =>
  apiClient.get(`/owner/support-tickets/${id}`);

export const getSupportTicketMessageById = (id) =>
  apiClient.get(`/owner/support-tickets/${id}/messages`);

export const replySupportTicketMessage = (data) =>
  apiClient.post("/owner/support-tickets/message", data);

export const startSupportTicketMessage = (id) =>
  apiClient.post(`/owner/support-tickets/${id}/start`);

export const resolveSupportTicketMessage = (id) =>
  apiClient.post(`/owner/support-tickets/${id}/resolve`);

export const closeSupportTicketMessage = (id) =>
  apiClient.post(`/owner/support-tickets/${id}/close`);

//................. Bill Type Master Api's...................//

export const getBillTypeList = () => apiClient.get("/owner/bill-types");

export const createBillTypes = (data) =>
  apiClient.post("/owner/bill-types/add", data);

export const getBillTypesById = (id) =>
  apiClient.get(`/owner/bill-types/${id}`);

export const updateBillTypesById = (id, data) =>
  apiClient.post(`/owner/bill-types/${id}/update`, data);

export const toggleBillTypeStatusById = (id, status) =>
  apiClient.post(`/owner/bill-types/${id}/toggle?isActive=${status}`);

//................. Payment Instruments Api's...................//

export const getPaymentInstrumentList = () =>
  apiClient.get("/owner/payment-instruments/modes");

//................. PG Management Api's...................//

//.. Dashboard ..//

export const getPGManagementDashboard = () =>
  apiClient.get("/owner/pg-management/dashboard");

//.. Properties ..//

export const getPGProperties = () =>
  apiClient.get("/owner/pg-management/properties");

export const getPGPropertiesAmenities = () =>
  apiClient.get("/owner/pg-management/amenities");

export const getPGPropertiesBId = (id) =>
  apiClient.get(`/owner/pg-management/properties/${id}`);

export const createPgProperties = (data) =>
  apiClient.post("/owner/pg-management/properties/add", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updatePgProperties = (id, data) =>
  apiClient.post(`/owner/pg-management/properties/${id}/edit`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const togglePgPropertiesStatus = (id) =>
  apiClient.post(`/owner/pg-management/properties/${id}/toggle`);

export const getPgPricingById = (id) =>
  apiClient.get(`/owner/pg-management/properties/${id}/pricing`);

export const updatePgPricingById = (id, data) =>
  apiClient.post(`/owner/pg-management/properties/${id}/pricing`, data);

//.. Rooms & Bed ..//

export const getPGPropertiesDropDown = () =>
  apiClient.get("/owner/pg-management/properties/dropdown");

export const getPGRooms = (pgPropertyId) =>
  apiClient.get("/owner/pg-management/rooms", {
    params: { pgPropertyId },
  });
export const getPgRoomsById = (id) =>
  apiClient.get(`/owner/pg-management/rooms/${id}`);

export const createPgRooms = (data) =>
  apiClient.post("/owner/pg-management/rooms/add", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updatePgRooms = (id, data) =>
  apiClient.post(`/owner/pg-management/rooms/${id}/update`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const removePgRooms = (id, data) =>
  apiClient.post(`/owner/pg-management/rooms/${id}/delete`);

export const toggleStatusPgRooms = (id) =>
  apiClient.post(`/owner/pg-management/rooms/${id}/toggle`);

//.. Sharing Type ..//

export const getPGSharingTypes = () =>
  apiClient.get("/owner/pg-management/sharing-types");

export const getPGSharingBedPricing = () =>
  apiClient.get("/owner/pg-management/sharing-types/all-property-pricing");

export const createPgSharingTypes = (data) =>
  apiClient.post("/owner/pg-management/sharing-types/add", data);

export const updatePgSharingTypes = (id, data) =>
  apiClient.post(`/owner/pg-management/sharing-types/${id}/edit`, data);

export const togglePgSharingTypes = (id) =>
  apiClient.post(`/owner/pg-management/sharing-types/${id}/toggle`);

export const removePgSharingTypes = (id) =>
  apiClient.post(`/owner/pg-management/sharing-types/${id}/delete`);

export const getPGSharingBedPricingById = (id) =>
  apiClient.get(`/owner/pg-management/properties/${id}/pricing`);

export const updatePGSharingBedPricingById = (id, data) =>
  apiClient.post(`/owner/pg-management/properties/${id}/pricing`, data);

//.. Food Management ..//

export const getMasterMealType = () => apiClient.get("/master/meal-types");

export const getFoodPlanPricing = (pgPropertyId) =>
  apiClient.get(`/owner/pg-management/properties/${pgPropertyId}/food-plans`);

export const getFoodPlanPricingById = (id) =>
  apiClient.get(`/owner/pg-management/food-plans/${id}`);

export const createFoodPlanPricing = (data) =>
  apiClient.post("/owner/pg-management/food-plans/add", data);

export const updateFoodPlanPricing = (id, data) =>
  apiClient.post(`/owner/pg-management/food-plans/${id}/update`, data);

export const toggleFoodPlanPricingStatus = (id) =>
  apiClient.post(`/owner/pg-management/food-plans/${id}/toggle`);

export const getTenantFoodAssignment = (pgPropertyId) =>
  apiClient.get(
    `/owner/pg-management/properties/${pgPropertyId}/tenant-food-assignments`,
  );

export const deleteFoodPlanPricing = (id) =>
  apiClient.post(`/owner/pg-management/food-plans/${id}/delete`);

//................. Add Coin On Owner Dashboard Api's...................//

export const getAddCoinCollectionMode = () =>
  apiClient.get("/master/collection-modes");

export const getCollectionModeId = (id) =>
  apiClient.get(`master/collectioninstrumentsOwner?modeId=${id}`);

export const addOwnerFundRequest = (data) =>
  apiClient.post("/owner/fund-requests/add", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

//................. Fund Request Api's...................//

export const getFundRequestStats = () =>
  apiClient.get("/owner/fund-requests/tenant-stats");

export const getFundRequestTenantList = (params) =>
  apiClient.get("/owner/fund-requests/tenant-list", { params });

export const approveFundRequest = (id) =>
  apiClient.post(`/owner/fund-requests/tenant-requests/${id}/approve`);

export const rejectFundRequest = (id, data) =>
  apiClient.post(`/owner/fund-requests/tenant-requests/${id}/reject`, data);

//................. API Settigs Api's...................//

//.. My Communction Settings ..//

export const getCommunicationSettings = () =>
  apiClient.get("/communication-settings");

export const updateCommunicationSettings = (data) =>
  apiClient.post("/communication-settings", data);

//.. Email Settings ..//

export const getCommunicationSettingsSmtp = () =>
  apiClient.get("/communication-settings/smtp");

export const getCommunicationSettingsSmtpById = (id) =>
  apiClient.get(`/communication-settings/smtp/${id}`);

export const insertUpdateCommunicationSettingsSmtp = (data) =>
  apiClient.post(`/communication-settings/smtp/upsert`, data);

export const deleteCommunicationSettingsSmtpById = (id) =>
  apiClient.post(`/communication-settings/smtp/${id}/delete`);

export const toggleCommunicationSettingsSmtpById = (id) =>
  apiClient.post(`/communication-settings/smtp/${id}/toggle`);

//.. Replacement Variable Api for SMS and WhatsApp ..//

export const getReplacementVariableforSmsAndWhatsapp = () =>
  apiClient.get("/communication-settings/sms-api/system-vars");

//.. SMS Settings ..//

export const getCommunicationSettingsSms = () =>
  apiClient.get("/communication-settings/sms-api");

export const getCommunicationSettingsSmsById = (id) =>
  apiClient.get(`/communication-settings/sms-api/${id}`);

export const insertUpdateCommunicationSettingsSms = (data) =>
  apiClient.post(`/communication-settings/sms-api/upsert`, data);

export const deleteCommunicationSettingsSmsById = (id) =>
  apiClient.post(`/communication-settings/sms-api/${id}/delete`);

export const toggleCommunicationSettingsSmsById = (id) =>
  apiClient.post(`/communication-settings/sms-api/${id}/toggle`);

//.. WhatsApp Settings ..//

export const getCommunicationSettingsWhatsApp = () =>
  apiClient.get("/communication-settings/whatsapp-api");

export const getCommunicationSettingsWhatsAppById = (id) =>
  apiClient.get(`/communication-settings/whatsapp-api/${id}`);

export const insertUpdateCommunicationSettingsWhatsApp = (data) =>
  apiClient.post(`/communication-settings/whatsapp-api/upsert`, data);

export const deleteCommunicationSettingsWhatsAppById = (id) =>
  apiClient.post(`/communication-settings/whatsapp-api/${id}/delete`);

export const toggleCommunicationSettingsWhatsAppById = (id) =>
  apiClient.post(`/communication-settings/whatsapp-api/${id}/toggle`);

//..  Notification Template for SMS, Whatsapp , Email ..//

export const getNotificationTemplateEmail = () =>
  apiClient.get("/notification-templates?channel=Email");

export const getNotificationTemplateEvent = () =>
  apiClient.get("/notification-templates/events");

export const getNotificationTemplateEventVariable = (id) =>
  apiClient.get(`/notification-templates/variables/${id}`);

export const getNotificationTemplateById = (id) =>
  apiClient.get(`/notification-templates/${id}`);

export const insertUpdateNotificationTemplate = (data) =>
  apiClient.post(`/notification-templates/upsert`, data);

export const deleteNotificationTemplate = (id) =>
  apiClient.post(`/notification-templates/${id}/delete`);

export const toggleNotificationTemplate = (id) =>
  apiClient.post(`/notification-templates/${id}/toggle`);

export const getNotificationTemplateSms = () =>
  apiClient.get("/notification-templates?channel=SMS");

export const getNotificationTemplateWhatsApp = () =>
  apiClient.get("/notification-templates?channel=WhatsApp");

//................. Owner Subscription Api's...................//

export const getOwnerSubscriptionCurrent = () =>
  apiClient.get("/owner/subscription/current");

export const getOwnerSubscriptionPlans = () =>
  apiClient.get("/owner/subscription/plans");

export const getOwnerSubscriptionHistory = (params) =>
  apiClient.get("/owner/subscription/history", { params });
